<template>
	<b-container fluid class="d-flex flex-column w-100 h-100 px-2">
		<b-row v-for="section in form.Sections" v-bind:key="section.Name" class="p-3 m-0">
			<b-col class="m-0">
				<b-card no-body class="p-3">
					<b-form-group
						:label="section.Label"
						label-cols="12"
						label-cols-lg="12"
						label-class="font-weight-bold text-dark pt-0 pb-2"
						label-align-sm="left"
						label-size="lg"
						class="m-0" />
					<b-button-toolbar v-if="ConsultMode !== objectDisplayingModeEnum.Read" key-nav :aria-label="$t('ToolbarButtons')">
						<b-button-group class="pt-1 pb-1">
							<!-- AddImage : Ajouter une image -->
							<b-button v-b-tooltip.hover :title="$t('AddImage')" @click="displayModal(undefined)" variant="outline-secondary" class="btn-circle-small p-0"><b-icon icon="file-earmark-plus" /></b-button>
						</b-button-group>
					</b-button-toolbar>
					<b-card no-body class="w-100">
						<b-card-header header-tag="header" header-bg-variant="secondary" class="text-center text-white font-weight-bold pt-0 pb-0" role="tab">{{$t('Photos')}}</b-card-header>

						<!-- Affiche des images sous la forme d'un caroussel -->
						<b-carousel ref="carousel" controls indicators no-animation v-model="currentImage" :interval="0">
							<b-carousel-slide v-for="image in imageItems" :key="image.Id" :caption="image.Description" :img-src="RES_URL + image.Url" >
								 <template #default v-if="ConsultMode !== objectDisplayingModeEnum.Read">
									<b-button v-b-tooltip.hover :title="$t('EditImage')" variant="secondary" @click="displayModal(image)" class="btn-circle shadow-sm p-0"><font-awesome-icon icon="pen"/></b-button>
									&nbsp; &nbsp; &nbsp;	
									<b-button v-b-tooltip.hover :title="$t('DeleteImage')" variant="secondary" @click="remove(image.Id)" class="btn-circle shadow-sm p-0"><b-icon icon="trash" /></b-button>
								</template>
							</b-carousel-slide>
						</b-carousel>
					</b-card>
				</b-card>
			</b-col>
		</b-row>
		<b-modal id="pictureModal" v-model="displayPicturesModal" centered>
			<template #modal-header="{ }">
				<!-- Photos : Photos -->
				<h6>{{$t('Photo')}}</h6>
			</template>
			<!-- <b-img :src="imgFile" fluid alt="Prévisualisation" /> -->
			 <!-- ImageFile : Fichier image -->
			<b-form-group v-if="!modifyMode"
				:label="$t('ImageFile')"
				label-cols-sm="4"
				label-for="picture"
				label-class="pt-0 pb-0 pr-0"
				label-align-sm="left"><!-- description="" -->
				<!-- FileSelectPlaceholder : Sélectionnez un fichier ou faites le glisser ici... -->
				 <!-- FileDropPlaceholder : Faites glisser un fichier ici... -->
				  <!-- Upload : Télécharge Img -->
				<b-input-group id="picture">
					<b-form-file
						v-model="imgFile"
						:placeholder="$t('FileSelectPlaceholder')"
						:drop-placeholder="$t('FileDropPlaceholder')"
						:browse-text="$t('Upload')"
						accept="image/jpeg, image/png, image/gif, image/bmp, image/tiff" />
				</b-input-group><!-- :state="Boolean(imgFile)" -->
			</b-form-group>
			<!-- Description : Description -->
			<b-form-group
				:label="$t('Description')"
				label-cols-sm="4"
				label-for="picDescription"
				label-class="pt-0 pb-0 pr-0"
				label-align-sm="left"><!-- description="" -->
				<b-input-group id="picDescription">
					<b-form-textarea
						v-model="imgDescription"
						rows="3"
						max-rows="15" />
				</b-input-group>
			</b-form-group>
			<template #modal-footer="{ cancel }">
				<!-- Cancel : Annuler -->
				<b-button @click="cancel()" pill variant="outline-secondary">{{$t('Cancel')}}</b-button>
				<!-- Validate : Valider -->
				<b-button v-if="modifyMode" @click="edit()" pill variant="secondary">{{$t('Validate')}}</b-button>
				<!-- Send : Envoyer -->
				<b-button v-else @click="uploadImage()" pill variant="secondary"><b-icon icon="file-earmark-plus" /> {{$t('Send')}}</b-button>
			</template>
		</b-modal>
	</b-container>
</template>

<script lang="ts">
	import { Watch } from "vue-property-decorator";
	import Component, { mixins } from 'vue-class-component';
	import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
	import ImageField from "@/types/fields/ImageField";
	import ImageItem from "@/types/fields/ImageItem";
	import ObjectDisplayingModeEnum from "@/enums/ObjectDisplayingModeEnum";
	import { PicturesUtils } from "@/components/commons/Utils";
	import { BaseObjectForm } from "./BaseObjectForm";
	import locales from "./locales/Pictures.json";

	/** Formulaire Photos de la fiche objet */
	@Component({
		components: { 
		},
		i18n: { messages: locales }
	})
	export default class Pictures extends mixins(PicturesUtils, BaseObjectForm) {
		/** Pour pouvoir utiliser l'enum FieldTypeEnum dans la section template */
		private fieldTypeEnum = FieldTypeEnum;
		private objectDisplayingModeEnum = ObjectDisplayingModeEnum;

		//#region Affichage de la fenêtre modale d'ajout d'un fichier image
		private displayPicturesModal: boolean = false;
		//#endregion Affichage de la fenêtre modale d'ajout d'un fichier image


		@Watch('form', {immediate: true})
		private updateImageItems() {
			if (this.form && this.form.Sections && (this.form.Sections[0].Fields[0] as ImageField).Value)
				this.imageItems = (this.form.Sections[0].Fields[0] as ImageField).Value as ImageItem[];
		}

		/** 
		 * Affichage de la fenêtre modale d'ajout d'une image
		 * @param item : ImageItem à charger dans la modale pour modification
		 *  */
		private displayModal(item: ImageItem) {
			this.editImg(item).then(() => {
				this.displayPicturesModal = true;
			});
		}

		/** Update/envoi de l'image au serveur */
		private uploadImage() {
			this.upload((data) => {
				return new Promise(async (resolve, reject) => {
					(this.form.Sections[0].Fields[0] as ImageField).Value.push(data);

					this.displayPicturesModal = false;
					
					resolve (true);
				});
			});
		}

		/** Edition de l'imageItemId en cours (édité par la Modale) */
		private edit() {
			this.editImgLst().then(() => {
				this.displayPicturesModal = false;
			});
		}

		/**
		 * Supprime une image du formulaire
		 * @param imageId Id de l'image à supprimer
		 */
		private remove(imageId: string) {
			this.removeImg(imageId, () => { return Promise.resolve(true); });
		}
	}
</script>

<style scoped>
	:deep(.custom-file-input:lang(fr) ~ .custom-file-label::after) {
		content: 'Naviguate';
	}
</style>